import { PropTypes } from "prop-types"

export const ITEM_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  info: PropTypes.string,
  value: PropTypes.string,
  contentSetId: PropTypes.string,
  category: PropTypes.string,
  type: PropTypes.string.isRequired,
  classificationTier: PropTypes.string,
})
